/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./scripts/swatchHelper.js ***!
  \*********************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function textSwap(target, textToSwap) {
  if (!target || !textToSwap) return;
  var str = textToSwap.innerHTML;
  target.innerHTML = str;
}
var swatchHelper = /*#__PURE__*/function (_HTMLElement) {
  _inherits(swatchHelper, _HTMLElement);
  var _super = _createSuper(swatchHelper);
  function swatchHelper() {
    var _this;
    _classCallCheck(this, swatchHelper);
    _this = _super.call(this);
    var selectors = {
      image: '[data-card-image]',
      swatchImg: '[data-swatch-image]',
      imgToSwap: '[data-card-swap]',
      price: '[data-price-variant]',
      priceTarget: '[data-price-target]',
      active: 'is-active'
    };

    // set a target to swap
    var target = _this.querySelector(selectors.image);
    var swatches = _this.querySelectorAll(selectors.swatchImg);
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        // toggle active classes and swaps the variant image into the main product card image
        var imageToSwap = e.target.querySelector(selectors.imgToSwap);
        var imageParent = e.target;
        var price = e.target.querySelector(selectors.price);
        var priceTarget = e.target.parentNode.parentNode.querySelector(selectors.priceTarget);
        var anyActiveClasses = _this.querySelectorAll("".concat(selectors.swatchImg, ".").concat(selectors.active)); // any 'is-active' classes

        _this.toggleSwap(target, imageToSwap);
        _this.removeAnyActiveClasses(anyActiveClasses, selectors.active);
        _this.addActiveClass(imageParent, selectors.active);
        textSwap(priceTarget, price);
      });
    });
    return _this;
  }

  // add a class
  _createClass(swatchHelper, [{
    key: "addActiveClass",
    value: function addActiveClass(elem, str) {
      if (!elem || !str) return;
      elem.classList.add(str);
    }

    // remove a class (string) from an element
  }, {
    key: "removeAnyActiveClasses",
    value: function removeAnyActiveClasses(arr, str) {
      arr.forEach(function (el) {
        el.classList.contains(str) ? el.classList.remove(str) : '';
      });
    }

    // copy the src, srcset, alt of an <img> to another <img>  
  }, {
    key: "toggleSwap",
    value: function toggleSwap(image1, image2) {
      if (!image1 || !image2) return;
      image1.src = image2.src;
      image1.srcset = image2.srcset;
      image1.alt = image2.alt;
    }
  }]);
  return swatchHelper;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (customElements.get('swatch-helper') === undefined) {
  customElements.get('swatch-helper') || customElements.define('swatch-helper', swatchHelper);
}
/******/ })()
;